import getBoardId from './getBoardId';
import dayjs from 'dayjs';

export function getStatsData() {
  const userDataString = localStorage.getItem('userData') ?? '{}';
  const userData = JSON.parse(userDataString);

  const today = dayjs();
  const yesterday = today.subtract(1, 'day');
  const todaysBoardId = getBoardId(today.format('YYYY-MM-DD'));
  const yesterdaysBoardId = getBoardId(yesterday.format('YYYY-MM-DD'));

  const boardIds = Object.keys(userData)
    .sort((a, b) => a - b)
    .filter(
      (boardId) =>
        userData[boardId] &&
        userData[boardId].isGameOver &&
        !isNaN(parseFloat(userData[boardId].score))
    );

  const scores = boardIds.map((boardId) => parseFloat(userData[boardId].score));

  const totalPlayed = scores.length;
  const bestScore = totalPlayed > 0 ? Math.min(...scores) : 'N/A';
  const averageScore =
    totalPlayed > 0
      ? Math.round(scores.reduce((acc, score) => acc + score, 0) / totalPlayed)
      : 'N/A';

  const wins = boardIds.filter((boardId) => !userData[boardId].board.flat().includes('')).length;
  const winPercentage = totalPlayed > 0 ? Math.round((wins / totalPlayed) * 100) : 0;

  // rarities
  const legendaries = boardIds.reduce(
    (acc, boardId) =>
      acc + userData[boardId].rarityPercentages.flat().filter((r) => parseFloat(r) < 5).length,
    0
  );
  const epics = boardIds.reduce(
    (acc, boardId) =>
      acc +
      userData[boardId].rarityPercentages
        .flat()
        .filter((r) => parseFloat(r) >= 5 && parseFloat(r) < 10).length,
    0
  );
  const rares = boardIds.reduce(
    (acc, boardId) =>
      acc +
      userData[boardId].rarityPercentages
        .flat()
        .filter((r) => parseFloat(r) >= 10 && parseFloat(r) < 20).length,
    0
  );

  // max streak
  let maxStreak = 0;
  let tempStreak = 0;

  for (let i = 0; i < boardIds.length; i++) {
    const current = parseInt(boardIds[i]);
    const prev = i > 0 ? parseInt(boardIds[i - 1]) : null;

    if (i === 0 || (prev && current - 1 === prev)) {
      tempStreak++;
    } else {
      tempStreak = 1;
    }

    maxStreak = Math.max(maxStreak, tempStreak);
  }

  // current streak
  let currentStreak = 0;
  const latestBoard = boardIds.length > 0 ? parseInt(boardIds[boardIds.length - 1]) : null;

  if (latestBoard && (latestBoard === todaysBoardId || latestBoard === yesterdaysBoardId)) {
    let current = 1;
    for (let i = boardIds.length - 1; i > 0; i--) {
      const currentBoard = parseInt(boardIds[i]);
      const previousBoard = parseInt(boardIds[i - 1]);

      if (previousBoard + 1 === currentBoard) {
        current++;
      } else {
        break;
      }
    }
    currentStreak = current;
  } else {
    currentStreak = 0;
  }

  // score distribution
  const scoreDistribution = {
    '0-99': 0,
    '100-199': 0,
    '200-299': 0,
    '300-399': 0,
    '400-499': 0,
    '500-599': 0,
    '600-699': 0,
    '700-799': 0,
    '800-900': 0,
  };
  const infinityScoreDistribution = {
    '0-99': 0,
    '100-199': 0,
    '200-299': 0,
    '300-399': 0,
    '400-499': 0,
    '500-599': 0,
    '600-699': 0,
    '700-799': 0,
    '800-900': 0,
  };
  for (let i = 0; i < boardIds.length; i++) {
    const boardId = boardIds[i];
    const isInfinite = userData[boardId].infiniteMode;
    const score = parseFloat(userData[boardId].score);

    const dist = isInfinite ? infinityScoreDistribution : scoreDistribution;

    if (score >= 800) dist['800-900']++;
    else if (score >= 700) dist['700-799']++;
    else if (score >= 600) dist['600-699']++;
    else if (score >= 500) dist['500-599']++;
    else if (score >= 400) dist['400-499']++;
    else if (score >= 300) dist['300-399']++;
    else if (score >= 200) dist['200-299']++;
    else if (score >= 100) dist['100-199']++;
    else dist['0-99']++;
  }

  return {
    currentStreak,
    maxStreak,
    averageScore,
    bestScore,
    totalPlayed,
    winPercentage,
    legendaries,
    epics,
    rares,
    scoreDistribution,
    infinityScoreDistribution,
  };
}
